export const EVENT_NAMES = {
  // アクション系
  SIGN_UP: "sign_up",
  LOGIN: "login",
  EDIT_PROFILE: "edit_profile",
  UPLOAD_PROFILE_AVATAR: "upload_profile_avatar",
  PURCHASE: "purchase",
  SEND_GOOD: "SEND_GOOD",
  ADD_FAVORITE: "ADD_FAVORITE",
  REMOVE_FAVORITE: "REMOVE_FAVORITE",
  COMPLETE_SEND_MESSAGE: "COMPLETE_SEND_MESSAGE",
  COMPLETE_SEND_ONE_TAP_MESSAGE_FROM_BOARD:
    "COMPLETE_SEND_ONE_TAP_MESSAGE_FROM_BOARD",
  COMPLETE_SEND_FREE_MESSAGE_FROM_BOARD:
    "COMPLETE_SEND_FREE_MESSAGE_FROM_BOARD",
  COMPLETE_SEND_GIFT: "COMPLETE_SEND_GIFT",
  COMPLETE_SEND_STAMP: "COMPLETE_SEND_STAMP",
  COMPLETE_BUY_IMAGE: "COMPLETE_BUY_IMAGE",
  COMPLETE_BUY_VIDEO: "COMPLETE_BUY_VIDEO",
  COMPLETE_BUY_AUDIO: "COMPLETE_BUY_AUDIO",
  TAP_OUTGOING_TO_VIDEO_LIST: "TAP_OUTGOING_TO_VIDEO_LIST",
  START_VIDEO_CALL: "START_VIDEO_CALL",
  START_VOICE_CALL: "START_VOICE_CALL",
  START_VIDEO_CHAT: "START_VIDEO_CHAT",
  CALL_STARTED: "CALL_STARTED",
  CALL_ENDED: "CALL_ENDED",
  CALL_ATTEMPT_ENDED: "CALL_ATTEMPT_ENDED",
  WATCH_VIDEO_CHAT_AS_FIRST_VIEWER: "WATCH_VIDEO_CHAT_AS_FIRST_VIEWER",
  WATCH_VIDEO_CHAT_AS_VIEWER: "WATCH_VIDEO_CHAT_AS_VIEWER",
  TAP_JOIN_VIDEO_CHAT_FROM_BOOKMARK_MODAL:
    "TAP_JOIN_VIDEO_CHAT_FROM_BOOKMARK_MODAL",
  INCOMING_VOICE_CALL: "INCOMING_VOICE_CALL",
  INCOMING_VIDEO_CALL: "INCOMING_VIDEO_CALL",
  OUTGOING_VOICE_CALL: "OUTGOING_VOICE_CALL",
  OUTGOING_VIDEO_CALL: "OUTGOING_VIDEO_CALL",
  SEND_VOICE_CALL_REQUEST: "SEND_VOICE_CALL_REQUEST",
  SEND_VIDEO_CALL_REQUEST: "SEND_VIDEO_CALL_REQUEST",
  SEND_MESSAGE_IN_VIDEO_CHAT: "SEND_MESSAGE_IN_VIDEO_CHAT",
  SEND_LOVENSE_IN_VIDEO_CHAT: "SEND_LOVENSE_IN_VIDEO_CHAT",
  SEND_LOVENSE_IN_VIDEO_CALL: "SEND_LOVENSE_IN_VIDEO_CALL",
  SEND_LOVENSE_FROM_QUICK_MENU: "SEND_LOVENSE_FROM_QUICK_MENU",
  SEND_GIFT_IN_VIDEO_CHAT: "SEND_GIFT_IN_VIDEO_CHAT",
  SEND_GIFT_IN_VIDEO_CALL: "SEND_GIFT_IN_VIDEO_CALL",
  // ページ表示系
  OPEN_GIRLS_ALL: "OPEN_GIRLS_ALL",
  OPEN_LIVE_LIST: "OPEN_LIVE_LIST",
  OPEN_CONVERSATION_ALL: "OPEN_CONVERSATION_ALL",
  OPEN_BOARD: "OPEN_BOARD",
  OPEN_GALLERY: "OPEN_GALLERY",
  OPEN_MYPAGE: "OPEN_MYPAGE",
  OPEN_FOOTPRINT_LIST: "OPEN_FOOTPRINT_LIST",
  OPEN_FLEA_MARKET: "OPEN_FLEA_MARKET",
  OPEN_PURCHASE: "OPEN_PURCHASE",
  OPEN_SEARCH: "OPEN_SEARCH",
  OPEN_VIDEO_LIST: "OPEN_VIDEO_LIST",
  OPEN_DAILY_BONUS: "OPEN_DAILY_BONUS",
  OPEN_PROFILE_DETAIL: "OPEN_PROFILE_DETAIL",
  // Repro のみ
  OPEN_RECOMMEND: "OPEN_RECOMMEND",
  RECOMMEND_TAP_SKIP: "RECOMMEND_TAP_SKIP",
  RECOMMEND_TAP_CALL: "RECOMMEND_TAP_CALL",
  RECOMMEND_TAP_LIKE: "RECOMMEND_TAP_LIKE",
  RECOMMEND_SWIPE_LEFT: "RECOMMEND_SWIPE_LEFT",
  RECOMMEND_SWIPE_RIGHT: "RECOMMEND_SWIPE_RIGHT",
  RECOMMEND_TAP_PROFILE: "RECOMMEND_TAP_PROFILE",
  RECOMMEND_TAP_PHOTO: "RECOMMEND_TAP_PHOTO",
  SHOW_CALL_POINT_SHORTAGE: "SHOW_CALL_POINT_SHORTAGE",
} as const;

export type EventName = (typeof EVENT_NAMES)[keyof typeof EVENT_NAMES];
